import React from "react";
import ReactDOM from "react-dom";
import ContextMenu from "../lib/ContextMenu";
import _ from "underscore";
import { TMenuItem } from "../types/models/TMenu";

const FONT_SIZE_ADJUSTMENT = 0.9;

/** The little menu button in a calendar's top-left corner. */
type TCalendarMenuProps = {
    menuItems: TMenuItem[];
    /** The calendar this menu belongs to; carried in the drag data. */
    calendarId?: number;
    size: { width: number; height: number };
    isActive?: boolean;
    /** True when the calendar has its own selection instead of the shared one. */
    isPrivate?: boolean;
    showId?: boolean;
};

class CalendarMenu extends React.Component<TCalendarMenuProps> {
    onClick = (event) => {
        ContextMenu.displayMenu(this.props.menuItems, event, _.noop);
    };

    onDragStart = (event) => {
        _.setDragData(event, "application/x-timeedit-calendar", this.props.calendarId);
        event.dataTransfer.effectAllowed = "move"; // eslint-disable-line
        if (event.dataTransfer.setDragImage) {
            event.dataTransfer.setDragImage(
                (ReactDOM.findDOMNode(this) as HTMLElement).parentNode as Element,
                0,
                0
            );
        }
    };

    getPrivateStyle = () => {
        const isWide = this.props.size.width > this.props.size.height;
        const isTall = this.props.size.height > this.props.size.width;

        const style: React.CSSProperties & { height: number; width: number } = {
            // eslint-disable-next-line no-magic-numbers
            height: !isWide ? this.props.size.height / 2 : this.props.size.height,
            // eslint-disable-next-line no-magic-numbers
            width: !isTall ? this.props.size.width / 2 : this.props.size.width,
        };
        style.lineHeight = `${style.height}px`;
        style.fontSize = Math.min(style.height, style.width) * FONT_SIZE_ADJUSTMENT;

        return style;
    };

    render() {
        const classes = {
            topLeft: true,
            inactive: !this.props.isActive,
            showId: this.props.showId,
        };

        let privateIcon: React.JSX.Element | null = null;
        if (this.props.isPrivate && !this.props.showId) {
            privateIcon = <div className="private" style={this.getPrivateStyle()} />;
        }

        const style: React.CSSProperties = {
            ...this.props.size,
            fontSize:
                Math.min(this.props.size.height, this.props.size.width) * FONT_SIZE_ADJUSTMENT,
            lineHeight: `${this.props.size.height}px`,
        };

        return (
            <div
                className={_.classSet(classes)}
                style={style}
                draggable={true}
                onClick={this.onClick}
                onContextMenu={this.onClick}
                onDragStart={this.onDragStart}
            >
                <span className="calendarId" data-cy="calendar-menu">
                    {(this.props.calendarId ?? 0) + 1}
                </span>
                {privateIcon}
            </div>
        );
    }
}

export default CalendarMenu;
